<template>
  <svg xmlns="http://www.w3.org/2000/svg" version="1.0" :width="width" :height="height" viewBox="0 0 300.000000 300.000000" preserveAspectRatio="xMidYMid meet">
    <g xmlns="http://www.w3.org/2000/svg" transform="translate(0.000000,300.000000) scale(0.100000,-0.100000)" :fill="iconColor" stroke="none">
      <path d="M965 2496 c-16 -8 -150 -135 -297 -282 -224 -226 -268 -275 -273 -305 -9 -49 15 -103 57 -129 33 -20 48 -20 1061 -20 878 0 1032 2 1056 14 85 44 83 179 -3 220 -31 14 -119 16 -892 16 l-859 0 152 153 c83 83 156 162 162 174 28 55 -4 134 -64 159 -42 17 -61 17 -100 0z"/>
      <path d="M463 1245 c-89 -38 -95 -164 -10 -215 31 -19 57 -20 890 -20 471 0 857 -3 857 -7 0 -4 -70 -77 -155 -163 l-155 -156 0 -47 c0 -39 5 -53 33 -83 39 -43 97 -55 143 -31 16 9 149 136 296 284 278 280 276 277 268 348 -4 37 -29 72 -64 89 -31 14 -130 16 -1053 16 -843 -1 -1023 -3 -1050 -15z"/>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: "IconCurrencyExchange",
    },
    width: {
      type: [Number, String],
      default: 20,
    },
    height: {
      type: [Number, String],
      default: 20,
    },
    iconColor: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
